import styled from 'styled-components';
import {ArrowLeftIconComponent, CloseIconComponent} from '@/components/Icons';
import {Flexbox, interceptProps} from '@/styled-components';
import {LAYOUT_SIZE, LAYOUT_Z_INDEX, palette} from '@/styles';
import {SearchInput} from '../AddressSearch/SearchInput';

interface IProps {
  initialValue?: string;
  hidden?: boolean;
  onFocus(): void;
  onPrev(): void;
  onClose(): void;
}

export const TopSearchBar = ({initialValue, hidden, onFocus, onPrev, onClose}: IProps) => {
  return (
    <Root hidden={hidden}>
      <BackButton onClick={onPrev} />
      <SearchInput value={initialValue} readOnly onClick={onFocus} />
      <CloseButton color={palette.black} onClick={onClose} />
    </Root>
  );
};

const Root = styled(Flexbox).withConfig({
  shouldForwardProp: interceptProps(['hidden']),
})<{
  hidden?: boolean;
}>`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: ${LAYOUT_Z_INDEX.NAVBAR};
  background-color: ${palette.white};
  height: ${LAYOUT_SIZE.MOBILE_MAP_TOP_BAR_HEIGHT}px;
  padding: 0 16px;
  box-shadow: 0px 2.064px 10.322px 0px rgba(0, 0, 0, 0.1);
  gap: 8px;
  ${({hidden}) => hidden && `visibility: hidden;`}
`;

const CloseButton = styled(CloseIconComponent)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer;
`;

const BackButton = styled(ArrowLeftIconComponent)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer;
`;
